import { createContext } from 'react';

/**
 * Portal target for the Revert/Save Priority Order buttons, set by
 * QueuePriorityModalContainer so they render in the modal's header row
 * (left of the close button) instead of QueuePriorityOrderView's own header.
 * Stays null when the view is mounted outside the modal (e.g. in tests),
 * in which case the buttons fall back to rendering inline.
 */
export const QueuePriorityHeaderActionsContext = createContext<HTMLDivElement | null>(null);
